module.exports = __webpack_public_path__ + "img/order_photo_image@3x.699fcf9f.png";